import Icon from '../components/Icon.vue'

Icon.register({
  snowflake: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M440.3 345.2c7.4 4.2 9.9 13.7 5.6 21l-15.5 26.8c-4.3 7.4-13.7 10-21.1 5.7l-33.8-19.5 7 26c2.2 8.2-2.7 16.7-10.9 18.9l-14.9 4c-8.2 2.2-16.7-2.7-18.9-10.9l-19-70.8-62.8-36.2v77.5l53.4 53.7c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-6.2 6.2-16.4 6.2-22.6 0l-19.7-19.7v40.4c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-40.3l-19.7 19.7c-6.2 6.2-16.4 6.2-22.6 0l-11.3-11.3c-6.3-6.2-6.3-16.4 0-22.6l53.7-53.7v-77.5l-62.8 36.2-19 70.8c-2.2 8.2-10.7 13.1-18.9 10.9l-14.9-4c-8.2-2.2-13.1-10.7-10.9-18.9l7-26-33.8 19.5c-7.4 4.2-16.8 1.7-21.1-5.7l-15.5-26.8c-4.2-7.4-1.7-16.8 5.7-21.1l33.8-19.6-26-7c-8.2-2.2-13.1-10.7-10.9-18.9l4-14.9c2.2-8.2 10.7-13.1 18.9-10.9l70.8 19 63.8-36.9-63.8-36.9-70.8 19c-8.2 2.2-16.7-2.7-18.9-10.9l-4-14.9c-2.2-8.3 2.7-16.8 11-19l26-7-33.8-19.5c-7.4-4.3-10-13.7-5.7-21.1l15.5-26.7c4.3-7.4 13.7-10 21.1-5.7l33.8 19.5-7-26c-2.2-8.2 2.7-16.7 10.9-18.9l14.9-4c8.2-2.2 16.7 2.7 18.9 10.9l19 70.8 62.8 36.2v-77.5l-53.7-53.7c-6.3-6.2-6.3-16.4 0-22.6l11.4-11.3c6.2-6.2 16.4-6.2 22.6 0l19.7 19.7v-40.4c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v40.4l19.8-19.7c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6l-53.7 53.7v77.5l62.8-36.2 19-70.8c2.2-8.2 10.7-13.1 18.9-10.9l14.9 4c8.2 2.2 13.1 10.7 10.9 18.9l-7 26 33.8-19.5c7.4-4.2 16.8-1.7 21.1 5.7l15.5 26.8c4.2 7.4 1.7 16.8-5.7 21.1l-33.8 19.5 26 7c8.2 2.2 13.1 10.7 10.9 18.9l-4 14.9c-2.2 8.2-10.7 13.1-18.9 10.9l-70.8-19-63.8 36.9 63.9 37 70.8-19c8.2-2.2 16.7 2.7 18.9 10.9l4 14.9c2.2 8.2-2.7 16.7-10.9 18.9l-26 7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/snowflake.js
// module id = 1911
// module chunks = 0